/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { TubSurveySession } from '../models/tub-survey-session';
@Injectable({
  providedIn: 'root',
})
class SurveyService extends __BaseService {
  static readonly SurveyGetSurveySessionsPath = '/survey/sessions';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Get all sessions that can be included in survey screening.
   * @return Ok
   */
  SurveyGetSurveySessionsResponse(): __Observable<__StrictHttpResponse<Array<TubSurveySession>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/survey/sessions`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<TubSurveySession>>;
      })
    );
  }
  /**
   * Get all sessions that can be included in survey screening.
   * @return Ok
   */
  SurveyGetSurveySessions(): __Observable<Array<TubSurveySession>> {
    return this.SurveyGetSurveySessionsResponse().pipe(
      __map(_r => _r.body as Array<TubSurveySession>)
    );
  }
}

module SurveyService {
}

export { SurveyService }
